import messages_ru from './ru.json'
import messages_en from './en.json'
import messages_tr from './tr.json'
import messages_vi from './vi.json'
import { brandMessages } from '../branding.ts'

export enum NativeAppLanguages {
  English = 'English',
  Russian = 'Russian',
  Turkish = 'Turkish',
  // Thai = 'Thai',
  Vietnamese = 'Vietnamese',
}

export type AppLanguages = 'en' | 'ru' | 'tr' | 'vi'
export type AppMessages = typeof messages_ru

export type AppMessageKeys = keyof AppMessages
// Translation values may contain the %TUTOR% branding token — substitute
// the configured tutor name once at load time.
export const messages: Record<AppLanguages, AppMessages> = {
  en: brandMessages(messages_en),
  ru: brandMessages(messages_ru),
  tr: brandMessages(messages_tr),
  vi: brandMessages(messages_vi),
}
export const languages = new Set(Object.keys(messages))
export const languagesMap: AppLanguages[] = ['en', 'ru', 'tr', 'vi']

export type BackendLanguages = Record<NativeAppLanguages, AppLanguages>
export const BackendLanguagesMap: BackendLanguages = {
  [NativeAppLanguages.English]: 'en',
  [NativeAppLanguages.Russian]: 'ru',
  [NativeAppLanguages.Turkish]: 'tr',
  [NativeAppLanguages.Vietnamese]: 'vi',
}

const DEFAULT_LOCALE: AppLanguages = 'en'

/** Безопасный locale + messages: никогда не отдаём undefined (иначе react-intl показывает ключи). */
export function resolveIntlLocale(
  locale: string | null | undefined,
): AppLanguages {
  if (locale && languages.has(locale)) {
    return locale as AppLanguages
  }
  return DEFAULT_LOCALE
}

export function getIntlMessages(locale: string | null | undefined): AppMessages {
  return messages[resolveIntlLocale(locale)]
}
